module.exports = __webpack_public_path__ + "img/t2-c16.ee59a745.png";